import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function QuarterThousandIllustration({
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3859">
      <div className="relative w-full h-full bg-gradient-to-br from-amber-100 to-orange-200 overflow-hidden" data-id="element-3860">
        {/* Background: Target rings */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3861">
          <circle cx="100" cy="95" r="70" fill="#FDE68A" opacity="0.4" data-id="element-3862" />
          <circle cx="100" cy="95" r="50" fill="#FCD34D" opacity="0.5" data-id="element-3863" />
          <circle cx="100" cy="95" r="30" fill="#FBBF24" opacity="0.55" data-id="element-3864" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[8%]" data-id="element-3865">
          <div className="w-[68%] h-[68%] flex items-center justify-center" data-id="element-3866">
            <DjaySpecimen look={{
            variant
          }} size="hero" emotion={isUnlocked ? 'proud' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3867" />
          </div>
        </div>

        {/* Foreground: "250" banner */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3868">
            <path d="M-10 32 Q100 60 210 32 L210 50 Q100 78 -10 50 Z" fill="#F97316" data-id="element-3869" />
            <text x="100" y="50" textAnchor="middle" fontFamily="sans-serif" fontSize="20" fontWeight="900" fill="white" data-id="element-3870">
              250
            </text>
            <circle cx="34" cy="150" r="7" fill="#FBBF24" data-id="element-3871" />
            <circle cx="166" cy="158" r="9" fill="#F59E0B" data-id="element-3872" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}